<template id="calendar">
  <div class="calendar">
  <header class="header">
    <button @click="previousMonth">&larr;</button>
    <span>{{ currentMonthLabel }} {{ currentYear }}</span>
    <button @click="nextMonth">&rarr;</button>
  </header>
  <div class="headings" v-for="(dayLabel, dayLabelIndex) in dayLabels" :key="dayLabelIndex+dayLabel">
    {{ dayLabel }}
  </div>
  <div v-for="(day, dateindex) in daysArray"
       class="day current"
       :key="dateindex"
       v-bind:class="[dayClassObj(day), showDates.indexOf(day.newDate) < 0 ? 'disabled': '']"
       >
    <button :key="dateindex" @click="setSelectedDate(day)">
      {{ day.date | formatDateToDay }}
    </button>
  </div>
</div>
</template>
<script>
import { EventBus } from "@/main";

const DAY_LABELS = ["S", "M", "T", "W", "Th", "F", "S"];
const MONTH_LABELS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];
export default {
  name: "calendar",

  data() {
    return {
      today: null,
      selectedDate: null,
      currDateCursor: null,
      dayLabels: null,
      showDates: []
    };
  },
  created() {
    this.dayLabels = DAY_LABELS.slice();
    this.today = new Date();
    this.selectedDate = this.today;
    this.currDateCursor = this.today;
  },
  props: {
    startDate: {
      required: false,
      type: Date
    }
  },
  computed: {
    currentMonth() {
      return this.currDateCursor.getMonth();
    },
    currentYear() {
      return this.currDateCursor.getFullYear();
    },
    currentMonthLabel() {
      return MONTH_LABELS[this.currentMonth];
    },
    daysArray() {
      const date = this.currDateCursor;
      const startOfMonth = dateFns.startOfMonth(date);
      const endOfMonth = dateFns.endOfMonth(date);
      //const days = dateFns.eachDay(startOfMonth, endOfMonth);

      const days = dateFns.eachDay(startOfMonth, endOfMonth).map(day => ({
        date: day,
        newDate: dateFns.format(day, "YYYY-MM-DD"),
        isCurrentMonth: dateFns.isSameMonth(
          new Date(this.currentYear, this.currentMonth),
          day
        ),
        isToday: dateFns.isToday(day),
        isSelected: dateFns.isSameDay(this.selectedDate, day)
      }));

      // gen the days from last month
      let previousMonthCursor = dateFns.lastDayOfMonth(
        dateFns.addMonths(date, -1)
      );
      const begIndex = dateFns.getDay(days[0].date);
      for (let i = begIndex; i > 0; i--) {
        days.unshift({
          date: previousMonthCursor,
          newDate: dateFns.format(previousMonthCursor, "YYYY-MM-DD"),
          isCurrentMonth: false,
          isToday: dateFns.isToday(previousMonthCursor),
          isSelected: dateFns.isSameDay(this.selectedDate, previousMonthCursor)
        });
        previousMonthCursor = dateFns.addDays(previousMonthCursor, -1);
      }

      // gen days for next month
      const daysNeededAtEnd = days.length % 7 > 0 ? 7 - days.length % 7 : 0;
      let nextMonthCursor = dateFns.addMonths(date, 1);
      nextMonthCursor = dateFns.setDate(nextMonthCursor, 1);
      for (let x = 1; x <= daysNeededAtEnd; x++) {
        days.push({
          date: nextMonthCursor,
          newDate: dateFns.format(nextMonthCursor, "YYYY-MM-DD"),
          isCurrentMonth: false,
          isToday: dateFns.isToday(nextMonthCursor),
          isSelected: dateFns.isSameDay(this.selectedDate, nextMonthCursor)
        });
        nextMonthCursor = dateFns.addDays(nextMonthCursor, 1);
      }
      return days;
    }
  },
  mounted() {
    EventBus.$on("showDate", showDate => {
      var dateString = showDate.replace(/-/g, "");
      var year = dateString.substring(0, 4);
      var month = dateString.substring(4, 6);
      var day = dateString.substring(6, 8);

      var date = new Date(year, month - 1, day);
      this.currDateCursor = date;
      this.selectedDate = date;
    });

    EventBus.$on("showDates", showDates => {
      showDates.map(singleDate => {
        this.showDates.push(singleDate.dateShow);
      });
    });
    console.log("this.showDates :", this.showDates);
  },
  methods: {
    dayClassObj(day) {
      return {
        today: day.isToday,
        current: day.isCurrentMonth,
        selected: day.isSelected
      };
    },
    nextMonth() {
      this.currDateCursor = dateFns.addMonths(this.currDateCursor, 1);
    },
    previousMonth() {
      this.currDateCursor = dateFns.addMonths(this.currDateCursor, -1);
    },
    setSelectedDate(day) {
      this.selectedDate = day.date;
      // console.log("this.selectedDate :", this.selectedDate);
      EventBus.$emit("currentDate", this.selectedDate);
      this.$emit("input", this.selectedDate);
    }
  },
  filters: {
    formatDateToDay(val) {
      return dateFns.format(val, "D");
    }
  }
};
// });
</script>
<style scoped>
.calendar {
  border: 1px solid var(--blue-grey);
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  width: 100%;
  background: #ffffff;
  box-shadow: 0px 5px 6px rgba(0, 0, 0, 0.2), 0px 3px 16px rgba(0, 0, 0, 0.12);
  border-radius: 14px;
  padding: 10px;
}
.calendar > .header {
  padding: 0.75rem;
  font-size: 1.25rem;
  grid-column: 1 / span 7;
}
.headings {
  color: #9fa0a4;
  font-weight: bold;
}

.calendar > .header > span {
  flex: 1;
  text-align: center;
  color: #000000;
  font-weight: bold;
  font-size: 16px;
}
.calendar > .header button {
  border: none;
  background: #fff;
  /* margin: 0 1rem; */
  font-size: 25px;
  padding: 0.25rem 0.5rem;
  font-weight: bold;
  outline: none;
  cursor: pointer;
}
.calendar > .header button:hover {
  color: #e70d00;

  transition: background 150ms;
}
.calendar > * {
  align-items: center;
  display: flex;
  justify-content: center;
}
.calendar > .day {
  color: #000000;
  font-size: 16px;
  font-weight: bold;
  height: 100%;
  width: 100%;
  border: 1px solid #e5e5e5;
}
.calendar > .day.selected {
  border: 1px solid #e5e5e5;
}
.calendar > .day.current {
  color: #212b36;
  cursor: pointer;
}
.calendar > .day::before {
  content: "";
  display: inline-block;
  height: 0;
  padding-bottom: 100%;
  width: 1px;
}
.calendar > .day button {
  color: inherit;
  background: transparent;
  border: none;
  height: 100%;
  width: 100%;
  color: #212b36;
  font-weight: bold;
  cursor: pointer;
  font-size: 14px;
}
.calendar > .day button.active,
.calendar > .day button:hover {
  background: linear-gradient(152.21deg, #e70d00 17.86%, #fa5402 126.35%);
  color: #fff;
  transition: background 150ms;
}
.calendar > .today {
  background: var(--grey);
  border-radius: 2px;
}
.day.disabled {
  opacity: 0.3;
  pointer-events: none;
}
.day.current.selected button {
  background: linear-gradient(169.24deg, #e70d00 17.86%, #fa5402 126.35%);
  color: #fff;
}
.text-center {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/partials/calendar.vue